export default "https://cdn-static.gokick.com/assets/28dce4dd80241a45018c00057f67470c3fae89ba/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";